import { MoreOutlined, FileTextOutlined, FileImageOutlined, CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import { FaRegFilePdf } from "react-icons/fa";
import { Checkbox, Dropdown, Image, Tooltip } from 'antd';
import React, { useState } from 'react'
import moment from "moment";
import ContractTypeBadge from "../../Common/components/ContractTypeBadge";
import { useEffect } from "react";
import axios from "axios";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { PropertyHandlers } from "../../PropertyComp/state/actions";
import { Loading } from "../../Common";
import { listingContractTypes } from "../../Common/commondata/commonData";
import ReSureSign from "../../Assets/Icons/Resure_icon.png";
import { formatBaseName } from "../../Common/utils/extraFunctions";

const OtherDocsTable = ({ otherDocsData, reSureSignDocs, handleOpenDoc, MenuItem, origin, listingItem, bos, agentDetails, delegate, isWeb, handleCheckboxChange, selectedItems }) => {
    const { propertyDocs, propertDocsLoading } = useSelector((state) => state.PropertyReducer,shallowEqual);
    const dispatch = useDispatch();
    const [sortOrder, setSortOrder] = useState("DESC")
    const toggleSortOrder = (order) => {
        setSortOrder((prevOrder) => (prevOrder === order ? null : order));
      };
 
      
    let unmounted = {
        value: false,
    };
    let sourceAxios = axios.CancelToken.source();

    useEffect(() => {
        if (origin === "PROPERTY_DOCS") {
            const params = {
                ...(listingItem?.isProperty ? { propertyId: listingItem?.propertyId } : {}),
                openFor: listingItem?.isProperty ? "SELLER_AGENT" : "BUYER_AGENT",
                ...(delegate ? { delegateSide: (listingItem?.isProperty) ? "SELLER" : "BUYER", delegateOwnerId: agentDetails?._id } : (bos && { delegateOwnerId: agentDetails?._id, screenType: "BOS" })),
                section: "PROPERTY_DOCS",
                queryPlatform: "WEB",
            };
            if (listingItem?.offerId || listingItem?.propertyId) {
                dispatch(PropertyHandlers.getPropertyDocsFun({ params, unmounted, source: sourceAxios }));
            }
            return () => {
                unmounted.value = true;
                sourceAxios.cancel("Cancelling in cleanup");
            }
        }
    }, [origin])
  
    const dataToRender = []
    if (origin === "TOOLS" && otherDocsData?.length > 0) {
        dataToRender.push(...otherDocsData);
    } else if (origin === "PROPERTY_DOCS_RE_SURE_SIGN" && reSureSignDocs?.length > 0) {
        dataToRender.push(...reSureSignDocs);
    } else if (propertyDocs?.length > 0 && !['PROPERTY_DOCS_RE_SURE_SIGN'].includes(origin)) {
        dataToRender.push(...propertyDocs.filter((el) => !listingContractTypes.includes(el?.contractType)));
    }
    let sortedData = [...dataToRender];
    if (sortOrder) {
      sortedData.sort((a, b) => {
        const aDate = new Date(a.createdDateMili || a.createdAt).getTime();
        const bDate = new Date(b.createdDateMili || b.createdAt).getTime();
        return sortOrder === 'ASC' ? aDate - bDate : bDate - aDate;
      });
    }
    return (
        <div
            style={{
                width: "100%",
                maxWidth: "800px",
                padding: "0 20px",
                overflow: "auto",
                borderRadius: "8px",
            }}
        >
            {origin === "PROPERTY_DOCS" && propertDocsLoading ? <Loading/> : 
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "15px",
                }}
            >
                <thead>
                    <tr
                        style={{
                            borderBottom: "1px solid #ccc",
                            backgroundColor: "hsl(211deg 75% 48%)",
                            color: "white",
                        }}
                    >
                        <th style={{ textAlign: "center", padding: "10px" }}>File Name</th>
                        <th style={{ textAlign: "center", padding: "10px" }}>
  <div style={{ display: "flex", gap: "5px", alignItems: "center", justifyContent: "center" }}>
    <div style={{ display: "flex", flexDirection: "column", cursor: "pointer", lineHeight: 1 }}>
      <CaretUpOutlined
        onClick={() => toggleSortOrder("DESC")}
        style={{ color: sortOrder === "DESC" ? "#FFBF00" : "#ffffff99" }}
      />
      <CaretDownOutlined
        onClick={() => toggleSortOrder("ASC")}
        style={{ marginTop: "-5px", color: sortOrder === "ASC" ? "#FFBF00" : "#ffffff99" }}
      />
    </div>
    <div style={{ fontWeight: "bold" }}>Creation Date</div>
  </div>
</th>
                        <th style={{ textAlign: "center", padding: "10px" }}>{origin === "TOOLS" ? "Options" : "Select"}</th>
                    </tr>
                </thead>
                <tbody>
                {sortedData?.length > 0 && sortedData.map((item, index) => (
                        <tr
                            key={index}
                            style={{
                                borderBottom: "1px solid #eee",
                                backgroundColor: index % 2 === 0 ? "#fafafa" : "white", // subtle striping
                            }}
                        >
                            <td
                            style={{
                            padding: "10px 5px 10px 30px",
                            verticalAlign: "middle",
                            cursor: origin === "PROPERTY_DOCS_RE_SURE_SIGN" ? "default" : "pointer",
                            }}
                            onClick={() => {
                            origin !== "PROPERTY_DOCS_RE_SURE_SIGN" && handleOpenDoc(item,"Listing_Doc");
                            }}
                        >
                            <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                            }}
                            >
                            {item.fileType === "IMAGE" ? (
                                <FileImageOutlined
                                style={{
                                    color: "#ecd540",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                }}
                                />
                            ) : item.fileType === "PDF" || item.isPdf || item.pdfLink ? (
                                <FaRegFilePdf
                                style={{
                                    color: "red",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                }}
                                />
                            ) : (
                                <FileTextOutlined style={{ color: "#74b3ed", fontSize: "18px" }} />
                            )}
                            <ContractTypeBadge contractType={item?.contractType} additionalStyle={{ fontSize: "12px" }} />
                            {origin === "PROPERTY_DOCS_RE_SURE_SIGN" ? (
                                <div>
                                <Tooltip title="RE-Sure Sign Document">
                                    <Image style={{ objectFit: "contain", width: "35px", verticalAlign: "middle" }} src={ReSureSign} preview={false} />
                                </Tooltip>
                                </div>
                            ) : (
                                ""
                            )}
                            <span
                                style={{
                                fontSize: "16px",
                                maxWidth: "270px",
                                whiteSpace: "nowrap",
                                fontWeight: "bold",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "inline-block",
                                }}
                            >
                                <Tooltip title={item?.updatedName || formatBaseName(item)} placement="top">
                                <span style={{ color: "blue" }}>{item?.updatedName || formatBaseName(item)}</span>
                                </Tooltip>

                                {item?.updatedName && (
                                <>
                                    <br />
                                    <Tooltip title={item?.documentName || item.fileName} placement="top">
                                    <span style={{ fontSize: "13px", color: "grey" }}>({item?.documentName || item.fileName})</span>
                                    </Tooltip>
                                </>
                                )}
                            </span>
                            </div>
                            </td>

                            <td style={{ textAlign: "center", padding: "10px" }}>
                                {origin === "TOOLS" ? item?.createdAt : 
                                origin === 'PROPERTY_DOCS_RE_SURE_SIGN' ? (
                                    <div>
                                        <div>{moment(item?.createdAt).format("MM/DD/YYYY")}</div>
                                        <div style={{ fontSize: "13px", color: "#777" }}>{moment(item?.createdAt).format("hh:mm A")}</div>
                                    </div>
                                ) : 
                                item?.createdDateMili ? (
                                    <div>
                                        <div>{moment(origin === "PROPERTY_DOCS" ? item?.createdDateMili : item?.createdAt).format("MM/DD/YYYY")}</div>
                                        <div style={{ fontSize: "13px", color: "#777" }}>{moment(origin === "PROPERTY_DOCS" ? item?.createdDateMili : item?.createdAt).format("hh:mm A")}</div>
                                    </div>
                                ) : (
                                    "--"
                                )}
                            </td>
                            {origin === "TOOLS" ? <td style={{ textAlign: "center", padding: "10px" }}>
                                <Dropdown trigger={["click", "hover"]} overlay={<MenuItem item={item} />}>
                                    <MoreOutlined
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "20px",
                                            color: "#085190",
                                        }}
                                    />
                                </Dropdown>
                            </td> : <td>
                            <Checkbox
                                checked={selectedItems.some((i) => i._id === item._id)}
                                onChange={(e) => handleCheckboxChange(e.target.checked, item)}
                            />
                            </td>}
                        </tr>
                    ))}
                </tbody>
            </table>}
        </div>
    )
}

export default OtherDocsTable
